/* eslint-disable complexity */
import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import Router from "next/router";
import { IconStar, IconPhone, IconComment, rdcUiTheme } from "@rdc-npm/rdc-ui";
import ShareProfile from "../../shared/atoms/ShareProfile/ShareProfile";
import config from "lib/config";
const backArrow = `${config.CDN_PREFIX}/static/assets/images/backArrow.png`;
const agentEmpty = `${config.CDN_PREFIX}/static/assets/images/Empty_AgentPhoto.svg`;
// import { removeHttpImageUrl } from "util/photo";
// import { insertInImgUrl } from "util/number";
import { getAgentPhoneNumber, getaAgenthref, generateRdcPixURL } from "util/agentdetailsUtil";
// import { generateRdcPixURL } from "util/imageFormat/index";
// import { rdcImgSm, rdcImgLg } from "util/imageFormat";

export default class AboutHeader extends Component {
  state = {
    showAboutHeader: false,
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  showShareModal = () => {
    if (this.props.showShareModal) {
      this.props.showShareModal();
    }
  };

  handleScroll = () => {
    if (window && window.pageYOffset > 510) {
      this.setState({ showAboutHeader: true });
    } else {
      this.setState({ showAboutHeader: false });
    }
  };
  // insertInImgUrl = (imgurl, txt, n) => {
  //   let a = imgurl;
  //   let b = txt;
  //   let position = imgurl && imgurl.length - n;
  //   let output = [a && a.slice(0, position), b, a && a.slice(position)].join("");
  //   return output;
  // };
  goToBack() {
    if (window.history && window.history.length > 1) {
      Router.back();
    } else if (localStorage.getItem("historyUrl")) {
      Router.push(localStorage.getItem("historyUrl"));
    }
  }
  render() {
    const { agentdetail, query, lang, clickDetectorAndScroll, deviceType } = this.props;
    const advertiser_id =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.advertiser_id;
    const isDotRealtor =
      query && query.isDotRealtor && JSON.parse(query.isDotRealtor) ? true : false;
    const isPromotedLDP =
      query && query.origin_source === "ldp_promote" && deviceType === "mobile" ? true : false;
    const agent_rating = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.agent_rating;
    const officenumber_arr =
      agentdetail &&
      agentdetail.agent_bio &&
      agentdetail.agent_bio.phones &&
      agentdetail.agent_bio.phones.filter(
        (m) =>
          m.type === "Mobile" ||
          m.type === "Office" ||
          m.type === "Home" ||
          m.type === "Toll Free" ||
          m.type === "tfn",
      );
    const officenumber = agentdetail && getAgentPhoneNumber(agentdetail);
    const number = agentdetail && getAgentPhoneNumber(agentdetail, true);

    const numberType = officenumber_arr && officenumber_arr[0] && officenumber_arr[0].type;
    const { settings } = agentdetail?.agent_bio;
    const imageProperties = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.photo;
    let imgurl = imageProperties && imageProperties.href;
    // const zoomValue =
    //   imageProperties && imageProperties.is_zoomed === false ? "d-w260_h260_q50" : "d-r7_w144";
    // imgurl = imgurl && removeHttpImageUrl(imgurl);
    // imgurl = imgurl && imgurl.replace("d-r1", "");
    // let profileUrl = imgurl
    //   ? /avatar.svg/.test(imgurl)
    //     ? insertInImgUrl(imgurl)
    //     : insertInImgUrl(imgurl, zoomValue, 4)
    //   : agentEmpty;
    let profileUrl = imgurl
      ? getaAgenthref("agent", agentdetail.agent_bio, agentEmpty)
      : agentEmpty;
    const isDefaultOrEmpty =
      profileUrl.includes("agent_default.png") || profileUrl.includes("Empty_AgentPhoto.svg")
        ? true
        : false;
    const background_photo =
      agentdetail &&
      agentdetail.agent_bio &&
      agentdetail.agent_bio.background_photo &&
      agentdetail.agent_bio.background_photo.href;
    const recommendationData = this.props && this.props.recommendationData;
    const reviewData = this.props && this.props.reviewData;
    const canShowRating = settings && settings.display_ratings;

    let background_photo_url;
    // var patt = /od-w/g;
    // var patt1 = /g01000000/g;
    // var patt2 = /c0ood/g;
    // var patt3 = /c0sod/g;
    // if (background_photo == null || patt1.test(background_photo)) {
    //   background_photo_url = "";
    // } else if (background_photo && patt.test(background_photo)) {
    //   background_photo_url = background_photo;
    // } else {
    //   background_photo_url = this.insertInImgUrl(background_photo, "od-w1024_h768_q50", 4);
    // }
    // if (patt2.test(background_photo_url)) {
    //   background_photo_url = background_photo_url.replace(patt2, "c0od");
    // }
    // if (patt3.test(background_photo_url)) {
    //   background_photo_url = background_photo_url.replace(patt3, "c0od");
    // }
    const callhref = "tel:" + officenumber;
    // // const backgroundImage = `url(${background_photo_url})`;

    // background_photo_url = background_photo_url && removeHttpImageUrl(background_photo_url);

    // background_photo_url =
    //   deviceType == "mobile"
    //     ? rdcImgSm(background_photo_url, "webp")
    //     : rdcImgLg(background_photo_url, "webp");
    background_photo_url =
      background_photo &&
      generateRdcPixURL(
        background_photo,
        deviceType == "mobile" ? "WEB_LDP_CAROUSEL" : "AGENT_LISTING",
      );
    return (
      <>
        <style jsx>{style}</style>

        <div
          id="profile_show_layout_id"
          data-review-url={{ profileUrl }}
          data-testid="component-stikyHeader">
          <div id="profile-info-section">
            {advertiser_id ? (
              <header
                className={
                  this.state.showAboutHeader
                    ? "_preview-main_header sticky"
                    : "_preview-main_header"
                }>
                <div className="container">
                  <div className="profile-details-box-profile">
                    <div className="profile-details">
                      <div
                        className="profile-img profile-details-box-team-section"
                        alt={
                          (!isDefaultOrEmpty
                            ? `Photo of ${agentdetail &&
                                agentdetail.agent_bio &&
                                agentdetail.agent_bio.person_name}`
                            : "") || ""
                        }>
                        {agentdetail && (
                          <img
                            className="profile-img"
                            src={profileUrl}
                            alt={
                              !isDefaultOrEmpty
                                ? `Photo of ${(agentdetail &&
                                    agentdetail.agent_bio &&
                                    agentdetail.agent_bio.person_name) ||
                                    ""}`
                                : ""
                            }
                          />
                        )}
                      </div>
                      <div className="profile-Tiltle">
                        {agentdetail && agentdetail.team && <div className="badge">(Team)</div>}
                        {agentdetail && (
                          <p className="profile-Tiltle-main">
                            {" "}
                            {agentdetail &&
                              agentdetail.agent_bio &&
                              agentdetail.agent_bio.person_name}
                          </p>
                        )}
                        {agentdetail && (
                          <p
                            className="profile-Tiltle-sub"
                            content={
                              agentdetail &&
                              agentdetail.agent_bio &&
                              agentdetail.agent_bio.office &&
                              agentdetail.agent_bio.office.name
                            }>
                            {agentdetail &&
                              agentdetail.agent_bio &&
                              agentdetail.agent_bio.office &&
                              agentdetail.agent_bio.office.name}
                          </p>
                        )}
                        <div className="profile-details-box">
                          <div className="profile-details-box-left">
                            <p className="stickyspace">
                              <>
                                {canShowRating ? (
                                  <span>
                                    {" "}
                                    <span className="review-star">
                                      <IconStar
                                        color={rdcUiTheme.color.interactive.primary.default.initial}
                                        size={2}
                                        role="img"
                                        focusable="false"
                                        label="profile-info"
                                      />
                                    </span>
                                    <span
                                      onClick={() =>
                                        clickDetectorAndScroll({ type: "rev", clicked: true })
                                      }
                                      className="track-my-clicks"
                                      data-linkname="realtors:agent_details:top:reviews_traverse"
                                      id="rev">
                                      {reviewData && reviewData.length > 0 ? (
                                        <>
                                          {" "}
                                          <span className="review">{agent_rating} </span>{" "}
                                          <span className="review1">
                                            {" "}
                                            ({reviewData && reviewData.length}){" "}
                                          </span>
                                        </>
                                      ) : (
                                        <span className="review1">
                                          {" "}
                                          {lang &&
                                            lang.ldp_content &&
                                            lang.ldp_content.not_yet_rated}{" "}
                                        </span>
                                      )}
                                    </span>
                                    <span className="separator-dot">.</span>
                                  </span>
                                ) : null}
                              </>

                              {recommendationData && recommendationData.length > 0 ? (
                                <>
                                  <span
                                    onClick={() =>
                                      clickDetectorAndScroll({ type: "rec", clicked: true })
                                    }
                                    className="track-my-clicks"
                                    data-linkname="realtors:agent_details:top:recommendations_traverse"
                                    id="rec">
                                    <span className="review-recommendations">
                                      <IconComment />
                                    </span>
                                    <span className="review">
                                      {recommendationData && recommendationData.length}
                                    </span>{" "}
                                    <span className="recommendations">
                                      {lang &&
                                        lang.ldp_content &&
                                        lang.ldp_content.recommendations_lower}
                                    </span>
                                  </span>
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <span className="review-recommendations">
                                    <IconComment />
                                  </span>{" "}
                                  <span className="review1">
                                    {" "}
                                    {lang &&
                                      lang.ldp_content &&
                                      lang.ldp_content.not_yet_recommended}
                                  </span>
                                </>
                              )}
                            </p>
                          </div>
                          <div className="contact-info-number-text sticky-contact">
                            {number ? (
                              <div className="icon-number-text">
                                <IconPhone
                                  color={rdcUiTheme.color.interactive.primary.default.initial}
                                  size={3}
                                  role="img"
                                  focusable="false"
                                  aria-label="profile-info"></IconPhone>
                              </div>
                            ) : null}
                            <div className="preview-contact-number ">
                              <p>
                                <a
                                  className="track-my-clicks"
                                  data-linkname="realtors:_details:top:phone_number"
                                  href={callhref}>
                                  {number}
                                </a>
                                {numberType ? (
                                  <span className=" mobile-number">
                                    {" "}
                                    {numberType == "tfn"
                                      ? "toll free"
                                      : numberType.toLowerCase()}{" "}
                                  </span>
                                ) : null}{" "}
                              </p>
                            </div>
                          </div>
                          <ShareProfile
                            stickyHeader={true}
                            showShareModal={this.showShareModal}
                            role="img"
                            focusable="false"></ShareProfile>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
            ) : null}
            <section className="banner_preview-main">
              <div id="cover_wrap">
                {isDotRealtor || isPromotedLDP ? null : (
                  <>
                    <img
                      className="fallBackImg"
                      alt=""
                      src="data:image/svg+xml;base64,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"
                    />
                    <div className="banner_preview-back" onClick={() => this.goToBack()}>
                      <div className="banner_preview-back-icon">
                        <img width="40px" height="40px" src={backArrow} alt="back_button" />
                      </div>
                      <div className="banner_preview-back-icon-right">
                        {lang && lang.ldp_content && lang.back_to_search}
                      </div>
                    </div>
                  </>
                )}
                {background_photo_url && /p.rdcpix.com/.test(background_photo_url) ? (
                  <div className="banner_preview">
                    <div className="banner_cover_photo">
                      <img
                        className="fallBackImg"
                        alt=""
                        src="data:image/svg+xml;base64,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"
                      />
                      <div className="banner_cover_photo_bg" id="bkg">
                        <img src={background_photo_url} alt="background_photo" />
                      </div>
                      <img src={background_photo_url} alt="background_photo" />
                    </div>
                  </div>
                ) : (
                  <div id="bkg" className="banner_preview default-image"></div>
                )}
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}

AboutHeader.defaultProps = {};

AboutHeader.propTypes = {
  agentdetail: PropTypes.object,
  deviceType: PropTypes.string,
  reviewData: PropTypes.array,
  recommendationData: PropTypes.array,
  showShareModal: PropTypes.func,
  query: PropTypes.object,
  lang: PropTypes.object,
  clickDetectorAndScroll: PropTypes.func,
};
